module.exports = __webpack_public_path__ + "media/application/images/ui/icon-address-80afa373dcaee2b6e72ee7105c9ddf65.png";